import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ConfigETC from "../Class/ConfigETC.json";
import {
  Class_ETC_Decrypt,
  formatDate,
  datagridtoolbarDynamicOptions,
  ConvertMiniutDuration_calbyconfig,
  excelExportProperties_ProjectView_GropBy,
  pdfExportProperties_ProjectView_GropBy,
  csvExportProperties_ProjectView_GropBy,
  Bind_Presets_Calendar,
  Bind_Select_Status,
} from "../Class/Class_Etc";
import Select from "react-select";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import SelectTaskMultiGroup from "../Library/Select_TaskMultiGroup";
import Pathurl from "../Class/Pathurl.json";
import { updateSampleSection } from "../Main/Sample-base";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Sort,
  Inject,
  Toolbar,
  ExcelExport,
  Resize,
  PdfExport,
  Group,
  Reorder,
} from "@syncfusion/ej2-react-grids"; //synfusion data grid

import SelectStaff from "../Library/Select_Staff";
import { customStylesSelect } from "../Class/Class_Etc"
import { CP_CheckPermission } from "../Class/Class_Permission";
	
/*

  Edit BY POOM : 09-05-2024 
    - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล

*/


                      

function PV_Task(props) {
  const location = useLocation();
  const isSVOT = CP_CheckPermission("service_list" , ["ot"],false,false);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [pgProid, setPgProid] = useState(-1);
  const [pgProName, setPgProName] = useState("");
  const [isFirst, setIsFirst] = useState(true);
  const [isCount, setIsCount] = useState(0);
  const [listdata, setListdata] = useState([]);
  const [isGroupByNone, setIsGroupByNone] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const dataPresets = Bind_Presets_Calendar();
  const [selectedGroupByValue, setSelectedGroupByValue] = useState("");
  const [searchstatus, setSearchstatus] = useState(null);
  const [iscntreset, setIscntreset] = useState(0);
  const [selectedOptionsTask, setSelectedOptionsTask] = useState([]);
  const [searchStaff, setSearchStaff] = useState([]);

  const [DaterangExport, setDaterangExport] = useState("");
  const [StaffExport, setStaffExport] = useState("");
  const [StatusExport, setStatusExport] = useState("");
  // const [ProjectExport, setProjectExport] = useState("");
  const [TaskExport, setTaskExport] = useState("");
  const [searchdetailGroupBy, setSearchdetailGroupBy] = useState("none");

  //#region __ Box ส่วนบน Project __
  function GetParameter(_callback) {
    let isNullParameter = false;
    let proid = "";
    let proName = "";
    try {
      if (location.state === null) {
        isNullParameter = true;
      } else {
        proid = Class_ETC_Decrypt(location.state?.proid.toString());
        proName = props.entity.pro_name;

        if (proid === "") {
          isNullParameter = true;
        }
      }
    } catch {
      isNullParameter = true;
    }

    if (isNullParameter) {
      window.location.replace("../" + Pathurl.m_project_view);
      if (_callback != null) {
        _callback();
      }
    } else {
      setPgProid(proid);
      setPgProName(proName);
      if (_callback != null) {
        _callback();
      }
    }
  }
  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }
  //#endregion

  //#region useEffect
  useEffect(() => {
    if (isFirst === true) {
      GetParameter(function () {
        GetConfig();
        if (isLoadedConfigData === true) {
          setSelectedGroupByValue("none");
          setIsGroupByNone(true);
          setIsSearch(true);
          BindList(pgProid, "none", "", "", "", "", "", function () {
            setIsLoadProgress(false);
            setIsFirst(false);
          });
        }
        updateSampleSection();
      });
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);

  //#endregion

  //#region __Bind Data
  async function BindList(
    pro_id,
    group_by,
    task_str,
    staff_str,
    date_start,
    date_end,
    ts_status,
    _callback
  ) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        pro_id: pro_id,
        group_by_str: group_by,
        task_id_str: task_str,
        staff_id_str: staff_str,
        date_start_str: date_start,
        date_end_str: date_end,
        status_str: ts_status,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_Task_GetListGroupByTime",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setListdata(json.data);
          setIsCount(json.total_Data);
          if (_callback != null) {
            _callback();
          }
        } else {
          // setPage(0);
          setListdata([]);
          if (_callback != null) {
            _callback();
          }
        }
      }
      else
      {
        setListdata([]);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      // setPage(0);
      if (_callback != null) {
        _callback();
      }
    }
  }

  //end region
  let gridInstance;
  let gridInstancePrint;
  
  //#region ################### Onchange DropDown List #######################
  function SearchonChangevaluesTask(e) {
    e === null ? setSelectedOptionsTask([]) : setSelectedOptionsTask(e);
  }

  function SearchonChangevaluesStaff(e) {
    e === null ? setSearchStaff([]) : setSearchStaff(e);
  }

  //#endregion

  //#region Custom Function

  const handleRadioGroupByChange = (event) => {
    setSelectedGroupByValue(event.target.value);
  };

  function onclickSearch() {
    let Date_start = "";
    let Date_end = "";
    let ValueStatus = "";
    let ValueStatusExport = "";
    let sTask = "";
    let sStaff = "";
    let sTask_export = "";
    let sStaff_export = "";

    if (selectedGroupByValue !== "none") {
      setIsGroupByNone(false);
    } else {
      setIsGroupByNone(true);
    }

    setSearchdetailGroupBy(selectedGroupByValue);

    if (selectedOptionsTask.length > 0) {
      for (let i = 0; i < selectedOptionsTask.length; i++) {
        sTask =
          sTask + (sTask === "" ? "" : ",") + selectedOptionsTask[i].value;
        sTask_export =
          sTask_export +
          (sTask_export === "" ? "" : ",") +
          selectedOptionsTask[i].label;
      }

      setTaskExport(sTask_export);
    }

    if (searchStaff.length > 0) {
      for (let i = 0; i < searchStaff.length; i++) {
        sStaff = sStaff + (sStaff === "" ? "" : ",") + searchStaff[i].value;
        sStaff_export =
          sStaff_export +
          (sStaff_export === "" ? "" : ",") +
          searchStaff[i].value;
      }
      setStaffExport(sStaff_export);
    }

    let date_rang = document.getElementById("txt_task_Date_rang").value;
    if (date_rang !== "") {
      const date = date_rang.split(" - ");
      Date_start = date[0];
      Date_end = date[1];
      setDaterangExport(date_rang);
    }

    if (searchstatus !== null) {
      if (searchstatus.length > 0) {
        for (let i = 0; i < searchstatus.length; i++) {
          ValueStatus = ValueStatus + (ValueStatus === "" ? "" : ",") + searchstatus[i].value;
          ValueStatusExport = ValueStatusExport + (ValueStatusExport === "" ? "" : ",") + searchstatus[i].label;
        }
      }
    }
    setStatusExport(ValueStatusExport);



    setIsLoadProgress(true);
    BindList(
      pgProid,
      selectedGroupByValue,
      sTask.toString(),
      sStaff.toString(),
      Date_start,
      Date_end,
      ValueStatus.toString(),
      function () {
        setIsLoadProgress(false);
      }
    );
  }

  function onclickReset() {
    setIscntreset((iscntreset) => iscntreset + 1);
    setSelectedOptionsTask([]);
    setSearchstatus(null);
    setSearchStaff([]);
    setSelectedGroupByValue("none")
    document.getElementById("txt_task_Date_rang").value = "";
  }

  //#endregion

  //#region valeAccessor

  const valueAccessDHM = (field, data, column) => {
    return ConvertMiniutDuration_calbyconfig(data[field]);
  };

  const valueTemp_Groupby=(props)=>{
    if (searchdetailGroupBy === "daily")
    {
      let day = props.ts_dateby.slice(0, 5);
      let date = props.ts_dateby.slice(5);
      return (<>
        <span className="text-muted text-smaller">{day}</span> {date}
        </>)
    }
    else
    {
      let ts_dateby = props.ts_dateby
      return (<>
          {ts_dateby}
        </>)
    }
  }
  //#endregion

  //#region ################### Toolbar Export and Export #######################

  function beforePrint(args) {
    let theadEle = gridInstance.element
      .querySelector(".e-gridheader .e-headercontent thead")
      .cloneNode(true);
    let arrOfMOM = theadEle.children;
    args.element
      .querySelector(".e-gridheader .e-headercontent thead")
      .replaceChildren(...[].slice.call(arrOfMOM));
  }

  function toolbarClick(args) {
    let Project = pgProName;
    let Task = TaskExport;
    let Staffs = StaffExport;
    let Daterang = DaterangExport;
    let Status = StatusExport;
    const DateExport = new Date();
    const DateExport1 = formatDate(
      DateExport,
      "short en",
      "en",
      "",
      "datetimeexport"
    );
    const DateExport2 = formatDate(
      DateExport,
      "short en",
      "en",
      "/",
      "datetime"
    );

    let Excelname = "Project_Task_Group_" + DateExport1 + ".xlsx";
    let PDFname = "Project_Task_Group_" + DateExport1 + ".pdf";
    let Csvname = "Project_Task_Group_" + DateExport1 + ".csv";
    let Report = "Project Task Group";
    // let colspan= 11;
    let colspan = (isGroupByNone === true ? 10 : 11);
    let iscv = (props.PermissionCostView ? 0 : 3);
    let isot = (isSVOT ? 0 : 2);

    if (gridInstance && args.item.id === "ExcelExport") {
      // isGroupByNone === true ? colspan = 10: colspan = 11 ;
      // props.PermissionCostView ? colspan = colspan - 0 : colspan =  colspan - 3;

      gridInstance.excelExport(
        excelExportProperties_ProjectView_GropBy(
          Excelname,
          Report,
          Project,
          (selectedGroupByValue === "none" ? "Transaction" : selectedGroupByValue),
          Task,
          Staffs,
          Daterang,
          Status,
          colspan - iscv - isot,
          DateExport2
        )
      );
    }

    if (gridInstance && args.item.id === "PdfExport") {

      gridInstance.pdfExport(
        pdfExportProperties_ProjectView_GropBy(
          PDFname,
          Report,
          Project,
          (selectedGroupByValue === "none" ? "Transaction" : selectedGroupByValue),
          Task,
          Staffs,
          Daterang,
          Status,
          DateExport2
        )
      );
    }

    if (gridInstance && args.item.id === "CsvExport") {

      gridInstance.csvExport(
        csvExportProperties_ProjectView_GropBy(
          Csvname,
          Report,
          Project,
          (selectedGroupByValue === "none" ? "Transaction" : selectedGroupByValue),
          Task,
          Staffs,
          Daterang,
          Status,
          colspan - iscv - isot,
          DateExport2
        )
      );
    }

    if (gridInstance && args.item.id === "Print") {
      
      gridInstancePrint.print();
    }

  }

  //#endregion

  //#region ###################  HTML ICON CSS in List Report ########################

  function fabtcTemplate(props) {
    return (
      <div>
        <span className="fab fa-btc text-muted"></span>
        &nbsp; {props.headerText}
      </div>
    );
  }
  function fapauseTemplate(props) {
    return (
      <div>
        <span className="far fa-pause-circle text-muted"></span>
        &nbsp; {props.headerText}
      </div>
    );
  }
  function falightTemplate(props) {
    return (
      <div>
        <span className="far fa-lightbulb text-muted"></span>
        &nbsp; {props.headerText}
      </div>
    );
  }
  function faclockTemplate(props) {
    return (
      <div>
        <span className="far fa-clock text-muted"></span>
        &nbsp; {props.headerText}
      </div>
    );
  }

  //#endregion

  return (
    <>
      {/* Start Over View Detail */}
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      <div>
        <div className="card-header">
          <div className="row">
            <div className="col-sm-12">
              <div>
                <div className="text-center">
                  {" "}
                  <h6>{isCount} tasks </h6>
                </div>
                <div className="search-icon float-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-toggle="collapse"
                    href="#collapse_task"
                  >
                    <i className="fas fa-filter" /> Filter
                  </button>
                </div>
              </div>
            </div>
            {/* /.col */}
          </div>
          {/* /.row */}
        </div>
        <div className="table-bordered bg-light" id="accordion_task">
          <div className="row">
            <div className="col-md-12">
              <div
                className="collapse"
                id="collapse_task"
                data-parent="#accordion_task"
              >
                <div className="row mt-3 mb-2">
                      <div className="col-lg-12 col-12 text-center">
                          <div className="form-group m-0">
                            
                            <div>
                            <label className="text-small text-normal pr-2 m-0 ">View data by</label>
                              <div className="icheck-primary d-inline ">
                                <input
                                  type="radio"
                                  id="rdo_task_Groupby_none"
                                  name="rdo_task_Groupby"
                                  value="none"
                                  checked={selectedGroupByValue === "none"}
                                  onChange={handleRadioGroupByChange}
                                />
                                <label htmlFor="rdo_task_Groupby_none" className="pr-3">
                                  <span className="pl-0">
                                    Transaction
                                  </span>
                                </label>
                              </div>
                              <div className="icheck-primary d-inline">
                                <input
                                  type="radio"
                                  id="rdo_task_Groupby_daily"
                                  name="rdo_task_Groupby"
                                  value="daily"
                                  checked={selectedGroupByValue === "daily"}
                                  onChange={handleRadioGroupByChange}
                                />
                                <label htmlFor="rdo_task_Groupby_daily" className="pr-3">
                                  <span className="pl-0">
                                    Daily
                                  </span>
                                </label>
                              </div>
                              <div className="icheck-primary d-inline">
                                <input
                                  type="radio"
                                  id="rdo_task_Groupby_weekly"
                                  name="rdo_task_Groupby"
                                  value="weekly"
                                  checked={selectedGroupByValue === "weekly"}
                                  onChange={handleRadioGroupByChange}
                                />
                                <label htmlFor="rdo_task_Groupby_weekly" className="pr-3">
                                  <span className="pl-0">
                                    Weekly
                                  </span>
                                </label>
                              </div>
                              <div className="icheck-primary d-inline">
                                <input
                                  type="radio"
                                  id="rdo_task_Groupby_monthly"
                                  name="rdo_task_Groupby"
                                  value="monthly"
                                  checked={selectedGroupByValue === "monthly"}
                                  onChange={handleRadioGroupByChange}
                                />
                                <label htmlFor="rdo_task_Groupby_monthly" className="pr-3">
                                  <span className="pl-0">
                                    Monthly
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                      </div>
                </div>

                <div className="row m-0 ">
                  <div className="col-lg-3 col-6">
                    <div className="form-group m-0">
                      <label className="text-small p-0 m-0">Date</label>
                      <div className="input-group">
                        <DateRangePickerComponent
                          id="txt_task_Date_rang"
                          placeholder="Select a range"
                          format="dd/MM/yyyy"
                          presets={dataPresets}
                          strictMode={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-6">
                    <div className="form-group m-0">
                      <label className="text-small p-0 m-0">Task</label>
                      {isLoadedConfigData && (
                        <SelectTaskMultiGroup
                          API_URL={configData.API_URL}
                          SelectTextDefault={ConfigETC.ddl_All}
                          resetSelect={iscntreset}
                          onChangevalue={SearchonChangevaluesTask}
                          iscloseMenuOnSelect={false}
                        ></SelectTaskMultiGroup>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-6">
                    <div className="form-group m-0">
                      <label className="text-small p-0 m-0">Staffs</label>
                      {isLoadedConfigData && (
                        <SelectStaff
                          API_URL={configData.API_URL}
                          staff_status={"-1"}
                          selectismulti={true}
                          SelectTextDefault={ConfigETC.ddl_All}
                          resetSelect={iscntreset}
                          onChangevalue={SearchonChangevaluesStaff}
                          iscloseMenuOnSelect={false}
                        ></SelectStaff>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-2 col-6">
                    <div className="form-group m-0">
                      <label className="text-small p-0 m-0">
                        Timesheet Status
                      </label>
                      <Select
                        closeMenuOnSelect={false}
                        placeholder={ConfigETC.ddl_All}
                        isMulti
                        value={searchstatus}
                        options={Bind_Select_Status("Rp_Sum_pro")}
                        menuPortalTarget={document.body}
                        onChange={(e) => setSearchstatus(e)}
                        styles={customStylesSelect}
                      />
                    </div>
                  </div>
                </div>
                <div className="row mt-3 p-0 mb-3">
                  
                  
                  <div className="col-12 text-center">
                    <div className="form-group m-0">
                    
                      <div className="card-tools">
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={onclickSearch}
                        >
                          <i className="fas fa-search" /> Search
                        </button>
                        &nbsp;
                        <button
                          type="button"
                          className="btn btn-default btn-sm"
                          onClick={onclickReset}
                        >
                          <i className="fas fa-times" /> reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /.card-header */}
        <div className="card-body border-0 m-0 p-0">
          {
          
          isSearch  && (
            <>
              <GridComponent
                id="dg_Project_Task"
                dataSource={listdata}
                allowPaging={true}
                allowSorting={true}
                allowResizing={true}
                allowReordering={true}
                pageSettings={{ pageCount: ConfigETC.pageCount,pageSize: ConfigETC.rowsPerPage,}}
                ref={(grid) => (gridInstance = grid)}
                toolbar={datagridtoolbarDynamicOptions(
                  listdata,
                  true,
                  true,
                  true,
                  true,
                  true
                )}
                toolbarClick={toolbarClick.bind(this)}

                allowExcelExport={true}
                allowPdfExport={true}
                allowGrouping={false}
                beforePrint={beforePrint.bind(this)}
                hierarchyPrintMode="All"
              >
                <ColumnsDirective>
                  <ColumnDirective
                    field="rowindex"
                    headerText="#"
                    width="5%"
                    textAlign="left"
                    allowSorting={false}
                  ></ColumnDirective>

                  {searchdetailGroupBy !== "none" && (
                    <ColumnDirective
                      field="ts_dateby"
                      headerText="View data by"
                      width="10%"
                      template={valueTemp_Groupby}
                      allowSorting={false}
                    ></ColumnDirective>
                  )}
                  <ColumnDirective
                    field="task_name"
                    headerText="Task"
                    width="15%"
                    allowSorting={false}
                  ></ColumnDirective>
                  <ColumnDirective
                    field="tasksub_name"
                    headerText="Sub Task"
                    width="15%"
                    allowSorting={false}
                  ></ColumnDirective>
                  <ColumnDirective
                    field="count_staff"
                    headerText="Staffs"
                    width="10%"
                    format="N0"
                  ></ColumnDirective>

                  <ColumnDirective
                    field="sum_worktime"
                    headerText="Work time"
                    width="11%"
                    headerTemplate={faclockTemplate}
                    valueAccessor={valueAccessDHM}
                  ></ColumnDirective>

                  {isSVOT &&
                    <ColumnDirective
                      field="sum_overtime"
                      headerText="Over time"
                      width="11%"
                      headerTemplate={falightTemplate}
                      valueAccessor={valueAccessDHM}
                    ></ColumnDirective>
                  }

                  <ColumnDirective
                    field="sum_timeoff"
                    headerText="TimeOff"
                    width="11%"
                    headerTemplate={fapauseTemplate}
                    valueAccessor={valueAccessDHM}
                  ></ColumnDirective>
                  {props.PermissionCostView && ( <ColumnDirective
                    field="sum_tc_worktime"
                    headerText="Work time Costs"
                    width="11%"
                    format="N2"
                    headerTemplate={fabtcTemplate}
                  ></ColumnDirective>)}
                  {props.PermissionCostView && isSVOT && ( <ColumnDirective
                    field="sum_tc_overtime"
                    headerText="Over time Costs"
                    width="11%"
                    format="N2"
                    headerTemplate={fabtcTemplate}
                  ></ColumnDirective>)}
                  <ColumnDirective
                    field="sum_tc_expenses"
                    headerText="Expense"
                    width="11%"
                    format="N2"
                    headerTemplate={fabtcTemplate}
                  ></ColumnDirective>
                </ColumnsDirective>
                <Inject services={[Page,
                                  Sort,
                                  Toolbar,
                                  ExcelExport,
                                  PdfExport,
                                  Group,
                                  Resize,
                                  Reorder,]} />
              </GridComponent>

              
              <div style={{display : "none"}} >
                <GridComponent
                  id="dg_Project_Task_Print"
                  dataSource={listdata}
                  allowPaging={true}
                  allowSorting={true}
                  allowResizing={true}
                  allowReordering={true}
                  pageSettings={{ pageCount: ConfigETC.pageCount,pageSize: ConfigETC.rowsPerPage,}}
                  ref={(grid) => (gridInstancePrint = grid)}
                  toolbar={datagridtoolbarDynamicOptions(
                    listdata,
                    true,
                    true,
                    true,
                    true,
                    true
                  )}
                  toolbarClick={toolbarClick.bind(this)}

                  allowExcelExport={true}
                  allowPdfExport={true}
                  allowGrouping={false}
                  beforePrint={beforePrint.bind(this)}
                  hierarchyPrintMode="All"
                >
                  <ColumnsDirective>
                    <ColumnDirective
                      field="rowindex"
                      headerText="#"
                      width="5%"
                      textAlign="left"
                      allowSorting={false}
                    ></ColumnDirective>

                    {searchdetailGroupBy !== "none" && (
                      <ColumnDirective
                        field="ts_dateby"
                        headerText="View data by"
                        width="10%"
                        allowSorting={false}
                      ></ColumnDirective>
                    )}
                    <ColumnDirective
                      field="task_name"
                      headerText="Task"
                      width="15%"
                      allowSorting={false}
                    ></ColumnDirective>
                    <ColumnDirective
                      field="tasksub_name"
                      headerText="Sub Task"
                      width="15%"
                      allowSorting={false}
                    ></ColumnDirective>
                    <ColumnDirective
                      field="count_staff"
                      headerText="Staffs"
                      width="10%"
                      format="N0"
                    ></ColumnDirective>

                    <ColumnDirective
                      field="sum_worktime"
                      headerText="Work time"
                      width="11%"
                      headerTemplate={faclockTemplate}
                      valueAccessor={valueAccessDHM}
                    ></ColumnDirective>

                    {isSVOT &&
                      <ColumnDirective
                        field="sum_overtime"
                        headerText="Over time"
                        width="11%"
                        headerTemplate={falightTemplate}
                        valueAccessor={valueAccessDHM}
                      ></ColumnDirective>
                    }

                    <ColumnDirective
                      field="sum_timeoff"
                      headerText="TimeOff"
                      width="11%"
                      headerTemplate={fapauseTemplate}
                      valueAccessor={valueAccessDHM}
                    ></ColumnDirective>
                    {props.PermissionCostView && ( <ColumnDirective
                      field="sum_tc_worktime"
                      headerText="Work time Costs"
                      width="11%"
                      format="N2"
                      headerTemplate={fabtcTemplate}
                    ></ColumnDirective>)}
                    {props.PermissionCostView && isSVOT && ( <ColumnDirective
                      field="sum_tc_overtime"
                      headerText="Over time Costs"
                      width="11%"
                      format="N2"
                      headerTemplate={fabtcTemplate}
                    ></ColumnDirective>)}
                    <ColumnDirective
                      field="sum_tc_expenses"
                      headerText="Expense"
                      width="11%"
                      format="N2"
                      headerTemplate={fabtcTemplate}
                    ></ColumnDirective>
                  </ColumnsDirective>
                  <Inject services={[Page,
                                    Sort,
                                    Toolbar,
                                    ExcelExport,
                                    PdfExport,
                                    Group,
                                    Resize,
                                    Reorder,]} />
                </GridComponent>
              </div>
            </>
          )}
        </div>

        {/* /.card-body */}
        {/* /.card-footer*/}
      </div>
    </>
  );
}

export default PV_Task;
